import React from "react";
import {TableDateSearchProvider} from "../../../admin/Context/TableDateSearchContext.jsx";
import {SystemOrders} from "./index.js";

export const SystemOrdersWrapper = () => {
    return (
        <TableDateSearchProvider localStorageKey="systemOrdersSearchDate">
            <SystemOrders />
        </TableDateSearchProvider>
    );
};
